import { useMemo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { content } from '../../components/content';
import { Wrapper } from './PageHome.style';

export type PageHomeProps = {
  firstPage?: FirstPage;
};

export function PageHome({ firstPage = 'generators' }: PageHomeProps) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('code');

  const Cmp = useMemo(() => {
    if (code) {
      return <content.Generators />;
    }

    switch (firstPage) {
      case 'browse-ideas':
        return <content.Browse />;
      case 'generators':
        return <content.Generators />;
      case 'create':
        return <Navigate to='/playground/blank' />;
      case 'image-to-3d':
        return <Navigate to='/labs/image-to-3d' />;
      default:
        return <></>;
    }
  }, [firstPage, code]);

  return (
    <Wrapper className='PageHome-wrapper' data-testid='PageHome-wrapper'>
      <Routes>
        <Route path='/' element={Cmp} />
        <Route path='/celebration/:celebrationType' element={<content.Celebration />} />
        <Route path='/account' element={<content.Account />} />
        <Route path='/api' element={<content.Api />} />
        <Route path='/asset-packs' element={<content.AssetPacks />} />
        <Route path='/browse' element={<content.Browse />} />
        <Route path='/discord' element={<content.Discord />} />
        <Route path='/docs' element={<content.Docs />} />
        <Route path='/events' element={<content.Events />} />
        <Route path='/pricing' element={<content.Pricing />} />
        <Route path='/generators' element={<content.Generators />} />
        <Route path='/hire-creator' element={<content.HireCreator />} />
        <Route path='/made-with-sloyd' element={<content.MadeWithSloyd />} />
        <Route path='/backdrops' element={<content.Backdrops />} />
        <Route path='/materials' element={<content.Materials />} />
        <Route path='/special' element={<content.Offer />} />
        <Route path='/plugins' element={<content.Plugins />} />
        <Route path='/projects' element={<content.Projects />} />
        <Route path='/settings' element={<content.Settings />} />
        <Route path='/textures' element={<content.Textures />} />
        <Route path='/tools' element={<content.Tools />} />
        <Route path='/tutorials' element={<content.Tutorials />} />
        <Route path='/use-cases' element={<content.UseCases />} />
        <Route path='/usage' element={<content.Usage />} />
        <Route path='/whats-new' element={<content.WhatsNew />} />
      </Routes>
    </Wrapper>
  );
}

export default PageHome;
